import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const axios = require("axios").default;

let app=createApp(App);

app.use(router).mount('#app')

